import { Checklist } from "@/bryntum-lib/models/Checklist";
import { AnimatedChecklistItemRow } from "@/react/components/entityViews/checklist/components/ChecklistItemRow";
import { useChecklistItemsData } from "@/react/hooks/entityHooks/useChecklistItemsData";
import { ListTodo } from "lucide-react";
import { AnimatePresence } from "motion/react";

interface ChecklistDetailLargeProps {
  checklist: Checklist;
}

const ChecklistDetailLargeWrapper = ({ checklist }: ChecklistDetailLargeProps) => {
  if (!checklist) return null;

  return <ChecklistDetailLarge checklist={checklist} />;
};

const ChecklistDetailLarge = ({ checklist }: { checklist: Checklist }) => {
  const { items: checklistItems } = useChecklistItemsData(checklist.id);
  return (
    <div>
      <div className="flex-1 overflow-y-auto space-y-4 animate-in fade-in duration-500">
        {/* Checklist Items */}
        <div className="">
          {checklistItems.length === 0 && (
            <div key="no-items" className="flex flex-col items-center justify-center mt-8">
              <div className="inline-flex items-center justify-center size-16 rounded-full bg-muted/50 mb-4">
                <ListTodo className="size-8 text-muted-foreground" />
              </div>
              <p className="text-muted-foreground text-sm">No items yet. Click the three dots above and "Edit Checklist" to add your first item.</p>
            </div>
          )}
          <AnimatePresence mode="popLayout" initial={false}>
            {checklistItems
              .sort((a, b) => a.order - b.order)
              .filter((item) => !!item.description)
              .map((item) => {
                return <AnimatedChecklistItemRow key={item.stableKey} item={item} className="pr-3" />;
              })}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default ChecklistDetailLargeWrapper;
